export const initialUploadResult = {
  status: 'DONE',
  failedList: [],
};
